import React from "react";

const AuthPageShell = ({ children }: { children: React.ReactNode }) => (
  <div
    className="d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed"
    style={{
      backgroundImage: `url('${process.env.PUBLIC_URL}/media/illustrations/login/sketch-1.png')`,
    }}
  >
    <div
      className="d-flex flex-center flex-column flex-column-fluid p-10 pb-lg-20"
      style={{ minHeight: "100vh" }}
    >
      {children}
    </div>
  </div>
);

export default AuthPageShell;
